"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authReferralContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
exports.authReferralContract = c.router({
    getReferrals: {
        method: 'GET',
        path: '/list',
        responses: {
            200: zod_1.z.array(zod_1.z.object({
                first_name: zod_1.z.string(),
                last_name: zod_1.z.string(),
                created_at: zod_1.z.coerce.date(),
                invitee_id: zod_1.z.string(),
                inviter_id: zod_1.z.string(),
                referral_id: zod_1.z.string(),
                inviter_bonus_status: zod_1.z.string(),
                invitee_bonus_status: zod_1.z.string(),
                bonus_scheme: zod_1.z.string(),
            })),
            400: c.type(),
        },
    },
}, {
    pathPrefix: '/auth',
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=referral.auth.contract.js.map